import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReceivingAdminService } from '../../../services/receiving-admin.service';
import { ReceivingOrder, ReceivingOrderListingResponse } from '../../../models/receiving.model';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TodayCountsService } from '../../../services/today-counts.service';
import { QuickStatsFilterService } from '../../../services/quick-stats-filter.service';
import { WebsocketrecivingService } from '@app/services/websocketreciving.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';


@Component({
    selector: 'app-receiving-orders-listing',
    templateUrl: './receiving-orders-listing.component.html',
    styleUrls: ['./receiving-orders-listing.component.scss']
})
export class ReceivingOrdersListingComponent implements OnInit, OnDestroy {
    orders: ReceivingOrder[] = [];
    isLoading: boolean = false;
    currentPage: number = 1;

    // Separate counts for each status
    allCount: number = 0;
    pendingCount: number = 0;
    successfulCount: number = 0;
    unsuccessfulCount: number = 0;
    cancelledCount: number = 0;

    totalOrders: number = 0; // Current total for pagination
    searchText: string = '';
    currentFilter: string = 'all';
    scrollProgress: number = 0;
    visibleRangeStart: number = 1;
    visibleRangeEnd: number = 0;

    // Header filter state
    headerFilterTab: string | null = null;
    headerOrderType: string | null = null;
    headerOrderDate: string | null = null;

    userTimeZone: any;
    private destroy$ = new Subject<void>();

    constructor(
        private receivingService: ReceivingAdminService,
        private router: Router,
        private todayCountsService: TodayCountsService,
        private quickStatsFilterService: QuickStatsFilterService,
        private recivingWebsocket: WebsocketrecivingService,
        public ShareddtaServices: ShareddtaService,
        private breadcrumbService: BreadcrumbService
    ) { }
    private subscriptionorderlisting!: Subscription;
    ngOnInit(): void {
        this.breadcrumbService.set([]); // Clear breadcrumbs on dashboard
        this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        //this.fetchOrders();
        //this.fetchOrderCounts();

        // Subscribe to header filters (Search and KPI tabs)
        this.quickStatsFilterService.quickStatsFilter$
            .pipe(takeUntil(this.destroy$))
            .subscribe(filter => {
                // 🔹 Guard: Only ignore if the filter is explicitly null (initial service state)
                // and we already have a restored value. If it's "", it's an explicit clear.
                if (filter.searchtext === null && this.searchText) {
                    console.log('ReceivingSync: Skipping initial null filter (preserving search)');
                    return;
                }

                this.searchText = filter.searchtext || '';
                this.headerFilterTab = filter.tab;
                this.headerOrderType = filter.orderType;
                this.headerOrderDate = filter.orderDate;

                // When header filter changes, re-fetch orders and counts
                this.fetchOrders(1);
                this.fetchOrderCounts();
            });

        this.receivingService.loading$
            .pipe(takeUntil(this.destroy$))
            .subscribe(loading => this.isLoading = loading);
        this.recivingWebsocket.connect()
        //for socket data
        this.subscriptionorderlisting = this.ShareddtaServices.data$.subscribe((incomingDataJson: string) => {
            try {
                // Parse the incoming JSON data into a JavaScript object
                const incomingData = JSON.parse(incomingDataJson);

                // Find the index of the item in the order list with the matching ID
                if (incomingData && this.orders) {
                    const indexToUpdate = this.orders.findIndex((item: { id: any; }) => item.id === incomingData.id);
                    if (incomingData.refresh === false) {
                        this.orders[indexToUpdate].eta[0].etda = incomingData?.eta[0]?.etda;
                        this.orders[indexToUpdate].order_status = incomingData?.order_status;
                    } else if (incomingData.refresh === true) {
                        console.log('Incoming data refresh is true');

                        // Add a guard to avoid multiple calls
                        console.log('Socket run: calling backToNormalMode1');
                        this.refresh();
                    }
                }
            } catch (error) {
                console.error('Error parsing incoming JSON data:', error);
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.subscriptionorderlisting.unsubscribe();
    }
    companyDriverPayload: any;
    fetchOrders(page: number = 1): void {
        this.currentPage = page;

        if (page === 1) {
            this.orders = [];
        }

        const status = this.currentFilter === 'all' ? undefined : this.currentFilter;

        this.receivingService.getReceivingOrders(
            page,
            this.searchText || undefined,
            status,
            this.headerOrderType ?? undefined,
            this.headerOrderDate ?? undefined
        )
            .pipe(takeUntil(this.destroy$))
            .subscribe((response: any) => {

                const data = response?.result || response;

                if (data && data.results) {

                    // 🔹 Existing order logic
                    if (page === 1) {
                        this.orders = data.results;
                    } else {
                        const existingIds = new Set(this.orders.map(o => o.id));
                        const uniqueNew = data.results.filter((o: any) => !existingIds.has(o.id));
                        this.orders = [...this.orders, ...uniqueNew];
                    }

                    this.totalOrders = data.count;

                    // Initialize range on first fetch
                    if (page === 1) {
                        this.visibleRangeStart = this.totalOrders > 0 ? 1 : 0;
                        this.visibleRangeEnd = Math.min(20, this.totalOrders);
                    }

                    // =========================
                    // 🔥 NEW LOGIC START
                    // =========================

                    const companyDriverMap = new Map();

                    this.orders.forEach((order: any) => {

                        const status = order?.order_status;

                        // ✅ sirf en-route aur arrived
                        if (status === 'en-route' || status === 'arrived') {

                            const companyId = order?.booked_in?.org_id;
                            const driver = order?.current_driver;

                            if (companyId && driver?.id) {

                                const fullDriverId = `${companyId}-${driver.id}`;

                                if (!companyDriverMap.has(companyId)) {
                                    companyDriverMap.set(companyId, new Map());
                                }

                                const driverMap = companyDriverMap.get(companyId);

                                // 🔥 duplicate avoid + full data store
                                if (!driverMap.has(fullDriverId)) {
                                    driverMap.set(fullDriverId, {
                                        driver_id: fullDriverId,
                                        driver_data: driver   // 👈 FULL OBJECT
                                    });
                                }
                            }
                        }
                    });

                    // 🔹 Final array format
                    this.companyDriverPayload = Array.from(companyDriverMap.entries()).map(
                        ([company_id, driverSet]) => ({
                            company_id: company_id.toString(),
                            driver_ids: Array.from(driverSet)
                        })
                    );
                    localStorage.setItem(
                        'companyDriverPayload',
                        JSON.stringify(this.companyDriverPayload)
                    );
                    console.log('FINAL PAYLOAD 👉', this.companyDriverPayload);

                    // =========================
                    // 🔥 NEW LOGIC END
                    // =========================


                    if (page > 1 && data.results.length === 0) {
                        this.totalOrders = this.orders.length;
                    }

                    if (this.currentFilter === 'all' && !this.searchText) {
                        this.allCount = data.count;
                    }

                } else if (Array.isArray(data)) {
                    this.orders = data;
                    this.totalOrders = data.length;
                }

            }, (error) => {
                this.isLoading = false;
            });
    }

    fetchOrderCounts(): void {
        const today = new Date().toISOString().split('T')[0];

        this.receivingService.getReceivingOrderCounts(
            undefined, // driver_id
            undefined, // order_status
            today,
            this.headerOrderType || undefined,
            this.headerOrderDate || undefined,
            this.searchText || undefined
        )
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                const data = response?.result || response;
                if (data) {
                    const statusSource = data.all || data;

                    // Group Pending, Enroute, Shipped, and Arrived under "Pending" count
                    const pCount = this.getStatusCount(statusSource, 'pending');
                    const eCount = this.getStatusCount(statusSource, 'en-route') || this.getStatusCount(statusSource, 'enroute');
                    const sCount = this.getStatusCount(statusSource, 'shipped');
                    const aCount = this.getStatusCount(statusSource, 'arrived');

                    this.pendingCount = pCount + eCount + sCount + aCount;

                    this.successfulCount = this.getStatusCount(statusSource, 'successful');
                    this.unsuccessfulCount = this.getStatusCount(statusSource, 'unsuccessful');
                    this.cancelledCount = this.getStatusCount(statusSource, 'cancelled');

                    // If 'all' count is provided in this object, use it
                    const totalFromStats = this.getStatusCount(statusSource, 'all');
                    if (totalFromStats > 0) this.allCount = totalFromStats;

                    // Update Top Header Stats (Receiving Dashboard)
                    const todayStats = data.today || data;
                    const delivery = this.getTypeCount(todayStats, 'delivery');
                    const pickup = this.getTypeCount(todayStats, 'pickup');
                    const activeDrivers = data.active_driver_count || 0;

                    this.todayCountsService.updateTodayCounts(delivery, pickup, activeDrivers);
                }
            });
    }

    private getStatusCount(data: any, status: string): number {
        if (!data) return 0;
        if (Array.isArray(data)) {
            const found = data.find((item: any) =>
                String(item.order_status || item.status || '').toLowerCase() === status.toLowerCase()
            );
            return found ? (Number(found.count) || 0) : 0;
        }
        const keys = Object.keys(data);
        const match = keys.find(k => k.toLowerCase() === status.toLowerCase());
        return match ? (Number(data[match]) || 0) : 0;
    }

    private getTypeCount(data: any, type: string): number {
        if (!data) return 0;
        if (Array.isArray(data)) {
            const found = data.find(item => String(item.order_type || '').toLowerCase() === type.toLowerCase());
            return found ? (Number(found.count) || 0) : 0;
        }
        return 0;
    }

    getFilterCount(filter: string): number {
        switch (filter) {
            case 'all': return this.allCount;
            case 'pending': return this.pendingCount;
            case 'successful': return this.successfulCount;
            case 'unsuccessful': return this.unsuccessfulCount;
            case 'cancelled': return this.cancelledCount;
            default: return 0;
        }
    }

    onSearch(): void {
        this.fetchOrders(1);
    }

    refresh(): void {
        this.fetchOrders(1);
        this.fetchOrderCounts();
    }

    clearFilters(): void {
        this.searchText = '';
        this.currentFilter = 'all';
        this.fetchOrders(1);
        this.fetchOrderCounts();
    }

    onBetaFeedback(): void {
        console.log('Navigating to beta feedback (Receiving side)');
        this.router.navigate(['/receiving-admin/beta-feedback']);
    }

    setFilter(filter: string): void {
        this.currentFilter = filter;
        this.fetchOrders(1);
        this.fetchOrderCounts();
    }

    isChipActive(filter: string): boolean {
        return this.currentFilter === filter;
    }

    getStatusClass(status: string): string {
        const s = status?.toLowerCase();
        if (s === 'pending') return 'pending';
        if (s === 'successful' || s === 'delivered' || s === 'completed') return 'successful';
        if (s === 'unsuccessful' || s === 'failed') return 'unsuccessful';
        if (s === 'cancelled') return 'cancelled';
        if (s === 'en-route' || s === 'in-transit' || s === 'enroute') return 'en-route';
        if (s === 'arrived') return 'arrived';
        if (s === 'warehouse') return 'warehouse';
        if (s === 'shipped') return 'shipped';
        return s || '';
    }

    onTableScroll(event: any): void {
        const scrollTop = event.target.scrollTop;
        const scrollHeight = event.target.scrollHeight;
        const clientHeight = event.target.clientHeight;

        // Update progress bar
        this.scrollProgress = (scrollTop / (scrollHeight - clientHeight)) * 100;

        if (scrollHeight - (scrollTop + clientHeight) <= 100 && !this.isLoading && this.orders.length < this.totalOrders) {
            this.fetchOrders(this.currentPage + 1);
        }

        // 🔹 Update Visible Range (Shipping Style)
        const rowHeight = 62;
        const pageSize = 20;
        const total = this.totalOrders || this.orders.length;

        let firstVisibleIndex = Math.floor(scrollTop / rowHeight);
        firstVisibleIndex = Math.min(firstVisibleIndex, Math.max(0, total - 1));

        const currentPageIndex = Math.floor(firstVisibleIndex / pageSize);
        this.visibleRangeStart = total > 0 ? (currentPageIndex * pageSize) + 1 : 0;
        this.visibleRangeEnd = Math.min((currentPageIndex + 1) * pageSize, total);
    }

    getPaginationInfo(): string {
        const total = this.totalOrders;
        if (!total || total === 0) {
            return 'No orders found';
        }
        return `Showing ${this.visibleRangeStart} - ${this.visibleRangeEnd} of ${total} orders`;
    }

    goToOrderDetail(order: ReceivingOrder): void {
        this.router.navigate(['/receiving-admin/orders/order-detail/', order.id], {
            queryParams: { schema: order.booked_in?.schema }
        });
    }

    formatETDA(etda: string): string {
        if (etda && etda.includes('-')) {
            const [datePart, timePart] = etda.split(' ');
            const [year, month, day] = datePart.split('-').map(part => parseInt(part));
            const [hour, minute, second] = timePart.split(':').map(part => parseFloat(part));
            const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
            const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: this.userTimeZone }));
            return localDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        } else {
            return etda || '';
        }
    }

    formatETDAs(item: any): string {
        if (!item || !item.status_history) return '';
        for (const statusItem of item.status_history) {
            if (statusItem.status === 'arrived') {
                const timestampUtc = statusItem.created_at;
                const dtObj = new Date(timestampUtc);
                return dtObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
            }
        }
        return '';
    }

    shouldShowETA(item: any): boolean {
        if (!item || !item.order_status) return false;
        const validStatus = ['en-route', 'shipped', 'warehouse', 'pending'];
        return (
            validStatus.includes(item.order_status) &&
            item.eta &&
            item.eta.length > 0 &&
            item.eta[0] &&
            item.eta[0].etda
        );
    }

    shouldShowArrived(order: any): boolean {
        return order && order.order_status === 'arrived';
    }

    convertTime24To12(val: any) {
        if (val != 'null' && val != '' && val) {
            let timeWithout00 = val.split(':');
            var time: any = timeWithout00[0] + ':' + timeWithout00[1];
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) {
                time = time.slice(1);
                time[5] = +time[0] < 12 ? ' AM' : ' PM';
                time[0] = +time[0] % 12 || 12;
            }
            return time.join('');
        }
        return '';
    }
}
